// The products-studios cluster refreshed on 2026-11-04: paths and reviewed
// dates, for the sitemap (gatsby-config.js), the legacy-canonical filter
// (lib/uv-printing-guide-canonical.js), gatsby-node's location skip list and
// the tests.
const designerToys = require('./designer-toy-production')
const customAwards = require('./custom-awards')
const { jewelry, manufacturing } = require('./product-services')
const { studios } = require('./studio-locations')

const pages = [
  designerToys.page,
  customAwards.page,
  jewelry.page,
  manufacturing.page,
  studios.brooklyn.page,
  studios.queens.page,
].map(({ path, reviewedDate }) => ({ path, reviewedDate }))

// Contentful location pages now owned by src/pages/locations/new-york/.
const codeOwnedLocationPaths = [
  studios.brooklyn.page.path,
  studios.queens.page.path,
]

module.exports = { pages, codeOwnedLocationPaths }
